/**
 * Utilitário para geração de Hash SHA-256 e Selagem de Tempo
 */

/**
 * Token de acesso do laudo (a "senha" de 6 caracteres que o paciente digita).
 * Alfabeto sem caracteres ambíguos (0/O, 1/I) para leitura no papel.
 * Usa CSPRNG (crypto.getRandomValues), não Math.random.
 */
export const generateAccessToken = (length = 6) => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const arr = new Uint32Array(length);
  crypto.getRandomValues(arr);
  let out = '';
  for (let i = 0; i < length; i++) out += chars[arr[i] % chars.length];
  return out;
};

export const generateReportHash = async (reportData) => {
  const text = JSON.stringify({
    content: reportData.content,
    patient: reportData.patientName,
    date: reportData.examDate,
    professional: reportData.signatureId,
    location: reportData.locationId,
    version: reportData.version || 1
  });
  
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

/**
 * Simula a geração de um Selo de Tempo (TSA - Time Stamping Authority)
 * Em produção, isso faria uma chamada para uma ACT homologada (ICP-Brasil)
 */
export const generateTimestampSeal = async (reportHash, serverTime) => {
  const nonce = crypto.randomUUID();
  const rawSeal = `${reportHash}|${serverTime}|${nonce}|LAUDANDO_ACT_2024`;
  
  const encoder = new TextEncoder();
  const data = encoder.encode(rawSeal);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const sealToken = hashArray.map(b => b.toString(16).padStart(2, '0')).join('').toUpperCase();
  
  return `LND-TSA-${sealToken.substring(0, 16)}`;
};

export const getClientFingerprint = async () => {
  try {
    const ipRes = await fetch('https://api.ipify.org?format=json').catch(() => ({ json: () => ({ ip: '0.0.0.0' }) }));
    const ipData = await ipRes.json();
    
    return {
      ip: ipData.ip,
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      timestamp: new Date().toISOString()
    };
  } catch (e) {
    return { error: 'Failed to capture fingerprint', timestamp: new Date().toISOString() };
  }
};